import { createFileRoute } from "@tanstack/react-router"
import { validateListSearch } from "@/features/list-search"
import { UsersPage } from "@/features/people/users-page"
export const Route = createFileRoute("/_authenticated/users/")({
    validateSearch: validateListSearch,
    component: UsersPage,
})
